import ChatMessages from './ChatMessages'

export default ChatMessages